/* @flow strict */

import * as React from 'react';
import PayoutsPageBody from './body';
import { Link, withRouter } from 'react-router-dom';
import { GET } from '/client/src/api/';
import NavbarTitleBackAction from '/client/src/components/topNavbar/backAction';

import './styles.scss';

type PropsType = {
  match: {
    params: {
      viewTab?: string
    }
  }
};

const items = [
  {
    link: 'payments',
    label: 'Payments'
  },
  {
    link: 'payouts',
    label: 'Payouts'
  }
];

const PayoutsPage = ({ match }: PropsType): React.Element<'div'> => {
  const {
    params: { viewTab }
  } = match;
  const [pending, setPending] = React.useState(true);
  const [rows, setRows] = React.useState([]);

  const [totalRows, setTotalRows] = React.useState(0);
  const [skipCount, setSkipCount] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [maxResultCount, setMaxResultCount] = React.useState(100);

  const [sortString, setSortString] = React.useState(false);
  const [sortDirection, setSortDirection] = React.useState('desc');

  const _viewTab = viewTab ? viewTab.toLowerCase() : 'payments';

  const sortingReformat = (key: string, dir: string): void => {
    setSortDirection(dir);

    let baseKey;

    switch (key) {
      case 'date':
        baseKey = 'payout_transaction_event_created_time_utc';
        break;
      default:
        baseKey = key;
        break;
    }

    setSortString(baseKey);
  };

  const requestUrl = _viewTab === 'payments'
      ? `/api/v1/1/merchants/payout_transactions?max_result_count=${maxResultCount}&skip_count=${skipCount}${sortString ? `&sorting=${sortString}+${sortDirection}` : ''}`
      : `/api/v1/1/merchants/payouts?max_result_count=${maxResultCount}&skip_count=${skipCount}${sortString ? `&sorting=${sortString}+${sortDirection}` : ''}`;

  const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
    return (
      <li
        key={`EventPageDetailCustomers-menuItems-${k}`}
        className={`${_viewTab === i.link ? 'active' : ''}`}
      >
        <Link to={`/pay/${i.link}`}>{i.label}</Link>
      </li>
    );
  });


  const fetchData = async () => {
    try {
      setPending(true);

      const { result } = await GET(requestUrl);

      setRows(result.items);
      setTotalRows(result.total_count);

      setPending(false);
    } catch (e) {
      console.log(e);
      console.error('Cant get reminders');

      setPending(false);
      setSortString(false);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setSkipCount(page * maxResultCount - maxResultCount);
  };

  React.useEffect(() => {
    fetchData();
  }, [skipCount, maxResultCount, sortString, sortDirection]);

  React.useEffect(() => {
    if (!!viewTab && !pending) {
      sortingReformat(viewTab === 'payments' ? 'payout_transaction_event_created_time_utc' : 'payout_event_created_time_utc', 'desc');
    }
  }, [viewTab]);

  return (
    <div className="sparxo-router-content">
      <NavbarTitleBackAction />
      <div className="sparxo-page-container">
        <div className="event-list">
          <div className="panel panel-default PayoutsPage">
            <div className="navbar-page-toolbar customers-navbar">
              <div className="container-fluid" style={{ height: '50px' }}>
                <ul className="nav hidden-520">{menuItems}</ul>

                <ul className="nav">
                  <li className="dropdown hide show-520">
                    <a
                      href="#"
                      className="dropdown-toggle"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="icon icon-bars" />
                    </a>
                    <ul className="dropdown-menu">{menuItems}</ul>
                  </li>
                </ul>
              </div>
            </div>

            <PayoutsPageBody
              progressPending={pending}
              data={rows}
              handleSort={sortingReformat}
              maxResultCount={maxResultCount}
              setMaxResultCount={setMaxResultCount}
              currentPage={currentPage}
              totalRows={totalRows}
              handlePageChange={handlePageChange}
              viewTab={_viewTab}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(PayoutsPage);
